export default async function sanitizeSW() {
  if (!navigator || !navigator.serviceWorker) return

  await navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      if (
        registration.active?.scriptURL &&
        registration.active?.scriptURL.includes('service-worker.js')
      )
        registration.unregister()
    })
  })
}
